module.exports = __webpack_public_path__ + "img/good-price-icon.e5e59df6.png";